import { Avatar, Box, Typography } from '@wishket/design-system';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

interface ArticleAuthorProps {
  name: string;
  href: string;
  imgUrl?: string;
  isDarkText?: boolean;
  openInNewTab?: boolean;
}

const ArticleAuthor = ({
  name,
  href,
  imgUrl,
  isDarkText = false,
  openInNewTab = false,
}: ArticleAuthorProps) => {
  return (
    <Link
      href={href}
      target={openInNewTab ? '_blank' : '_self'}
      data-testid="contents-author-root"
    >
      <Box className="flex w-fit items-center gap-2">
        <Avatar size="sm" imgUrl={imgUrl} />
        <Typography
          variant="body2"
          className={twMerge(
            'text-w-gray-400 hover:underline',
            isDarkText && 'text-w-gray-700'
          )}
          data-testid="contents-author-name"
        >
          {name}
        </Typography>
      </Box>
    </Link>
  );
};

export default ArticleAuthor;
